// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "title-1qt38";
var _4 = "slider-1VaRu";
export { _1 as "__esModule", _2 as "tablet", _3 as "title", _4 as "slider" }
export default { "__esModule": _1, "tablet": _2, "title": _3, "slider": _4 }
